import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { getData } from "../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../interfaces/response";
import { ILockReason } from "./useGetLockReasons";

const getUnlockReasons = async (): Promise<IResponse<ILockReason[]>> => {
  const { data } = await getData(ajaxEndpoints.UNLOCK_REASONS);

  return data;
};

export default function useGetUnlockReasons() {
  return useQuery<IResponse<ILockReason[]>, Error>(
    ["getUnlockReasons"],
    getUnlockReasons,
    {
      refetchOnWindowFocus: false,
    },
  );
}
